/* global axios */
import ApiClient from './ApiClient';

class BulkBroadcastsAPI extends ApiClient {
  constructor() {
    super('bulk_broadcasts', { accountScoped: true });
  }

  pause(id) {
    return axios.post(`${this.url}/${id}/pause`);
  }

  resume(id) {
    return axios.post(`${this.url}/${id}/resume`);
  }

  // Cancela o que ainda nao saiu (pending/queued -> skipped) e encerra.
  cancelRemaining(id) {
    return axios.post(`${this.url}/${id}/cancel_remaining`);
  }

  duplicate(id) {
    return axios.post(`${this.url}/${id}/duplicate`);
  }

  previewSplit(params) {
    return axios.post(`${this.url}/preview_split`, params);
  }

  retryFailed(id) {
    return axios.post(`${this.url}/${id}/retry_failed`);
  }

  previewAudience(payload) {
    return axios.post(`${this.url}/preview_audience`, payload);
  }
}

export default new BulkBroadcastsAPI();
